/**
 * Testarossa redux reducers and initial state
 * @module services/testarossa/redux/reducers
 */
import { Map } from 'immutable'
import {
  GET_TESTAROSSA_PROJECTS,
  SET_TESTAROSSA_PROJECTS_PROCESSING,
  SET_TESTAROSSA_PROJECTS_ERROR,
  SET_TESTAROSSA_CAMPAIGNS_ERROR,
  SET_TESTAROSSA_PROJECTS_DATA,
  SET_TESTAROSSA_CAMPAIGN_DATA,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload = {}, type } = action
  switch (type) {
    case SET_TESTAROSSA_CAMPAIGNS_ERROR: {
      const { error } = payload
      return state.setIn(['campaigns', 'error'], error)
    }
    case SET_TESTAROSSA_CAMPAIGN_DATA: {
      const { uuid, data } = payload
      return state.setIn(['campaigns', 'data', uuid], data)
    }
    case GET_TESTAROSSA_PROJECTS:
    case SET_TESTAROSSA_PROJECTS_PROCESSING: {
      const { processing = true } = payload
      return state.setIn(['projects', 'processing'], processing)
    }
    case SET_TESTAROSSA_PROJECTS_ERROR: {
      const { error } = payload
      return state.setIn(['projects', 'error'], error)
        .deleteIn(['projects', 'processing'])
    }
    case SET_TESTAROSSA_PROJECTS_DATA: {
      const { data, processing } = payload
      return state.setIn(['projects', 'data'], data)
        .setIn(['projects', 'processing'], processing)
        .deleteIn(['projects', 'error'])
    }
    default:
      return state
  }
}
